import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from '@angular/router';
import {StateStorageService} from '../services/state-storage.service';
import {CommonFunctionsService} from '../services/common-functions.service';
import {of} from 'rxjs/internal/observable/of';


@Injectable({
    providedIn: 'root'
})
export class EditGuard implements CanDeactivate<any> {

    constructor(private appState: StateStorageService,
                private commonFunctionsService: CommonFunctionsService) {
    }

    canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot): Promise<boolean> {
        if (this.appState.editAction) {
            return this.commonFunctionsService.askCancelEdit();
        }
        return <Promise<boolean>>of(true).toPromise();
    }
}
